<template>
  <v-list theme="dark" bg-color="transparent" active-class="text-white">
    <v-list-item
      v-for="(route, idx) in routes"
      :key="idx"
      :to="route.path"
      :title="route.label"
      :data-testid="route.label"
    />
  </v-list>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import sl from '@/serviceLocator';

export default defineComponent({
  setup() {
    const store = sl.get('store');
    const hasCommentPermission = store.hasPermission('ADD_COMMENTS');

    const routes = [
      { label: 'Profile', path: 'profile' },
      { label: 'Drafts', path: 'drafts' },
      hasCommentPermission
        ? { label: 'Comments', path: 'comments' }
        : { label: 'Preferences', path: 'preferences' },
    ];

    return {
      routes,
      hasCommentPermission,
    };
  },
});
</script>
